import styled, { css, keyframes } from 'styled-components'

const fadeInScale = keyframes`
  from {
    opacity: 0;
    transform: scale(0.96) translateY(12px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
`

export const Wrapper = styled.div<{ $borderRadius?: string }>`
  ${({ $borderRadius }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: ${props => props.theme.background.secondary};
    border-radius: ${$borderRadius || '16px'};
    border: 1px solid ${props => props.theme.colors.borderColorPrimary};
    box-shadow: 0 24px 60px -16px rgba(0, 0, 0, 0.4), 0 8px 20px rgba(0, 0, 0, 0.12);
    animation: ${fadeInScale} 0.32s cubic-bezier(0.32, 0.72, 0, 1);
    overflow: visible;

    & > *:first-child {
      border-top-left-radius: ${$borderRadius || '16px'};
      border-top-right-radius: ${$borderRadius || '16px'};
    }

    & > *:last-child {
      border-bottom-left-radius: ${$borderRadius || '16px'};
      border-bottom-right-radius: ${$borderRadius || '16px'};
    }
  `}
`
